import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-1006dd21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full relative" }
const _hoisted_2 = { class: "absolute top-0 right-0 z-10" }
const _hoisted_3 = { class: "flex flex-row p-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "close"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($setup.mode === $setup.MODES.discussion)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.players, (p) => {
              return (_openBlock(), _createBlock($setup["Avatar"], {
                key: p._id,
                layout: p.profile.avatar,
                class: "w-24 h-24 -mr-8"
              }, null, 8 /* PROPS */, ["layout"]))
            }), 128 /* KEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($setup.currentPlayer)
                ? (_openBlock(), _createBlock($setup["Avatar"], {
                    key: 0,
                    layout: $setup.currentPlayer.profile.avatar,
                    class: "w-24 h-24 -mr-4"
                  }, null, 8 /* PROPS */, ["layout"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */)),
        _createVNode($setup["Button"], {
          class: "pointer-events-auto ml-4 bg-white m-6",
          childclass: 'w-12 h-12',
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.finish()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        ($setup.mode === $setup.MODES.intro)
          ? (_openBlock(), _createBlock($setup["Intro"], {
              key: 0,
              title: $setup.t('title'),
              description: $setup.t('description'),
              "exercise-index": $setup.exerciseIndex,
              image: $setup.boatImage
            }, {
              default: _withCtx(() => [
                _createVNode($setup["Button"], {
                  backgroundcolour: 'bg-sl-green-button',
                  textcolour: 'text-white',
                  childclass: 'text-2xl border-none h-16 w-56',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeMode($setup.MODES.playerReady)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('getStarted')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "description", "exercise-index", "image"]))
          : ($setup.mode === $setup.MODES.playerReady && $setup.currentPlayer)
            ? (_openBlock(), _createBlock($setup["PlayerReady"], {
                key: 1,
                description: $setup.t('yourTurn'),
                player: $setup.currentPlayer
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["Button"], {
                    backgroundcolour: 'bg-sl-green-button',
                    textcolour: 'text-white',
                    childclass: 'text-2xl border-none h-16 w-56',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeMode($setup.MODES.fishing)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('imReady')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["description", "player"]))
            : ($setup.mode === $setup.MODES.fishing && $setup.currentPlayer && $setup.currentItem)
              ? (_openBlock(), _createBlock($setup["Fishing"], {
                  key: 2,
                  item: $setup.currentItem,
                  onDone: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeMode($setup.MODES.quizz))),
                  onPlayinstruction: $setup.playInstructionSound
                }, null, 8 /* PROPS */, ["item"]))
              : (($setup.mode === $setup.MODES.quizz || $setup.mode === $setup.MODES.wordFocus) && $setup.currentPlayer && $setup.currentItem)
                ? (_openBlock(), _createBlock($setup["ItemDetail"], {
                    key: 3,
                    item: $setup.currentItem
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["Button"], {
                        backgroundcolour: 'bg-sl-green-button',
                        textcolour: 'text-white',
                        childclass: 'text-2xl border-none p-5',
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeMode($setup.MODES.discussion)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('letsDiscuss')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["item"]))
                : ($setup.mode === $setup.MODES.discussion && $setup.currentPlayer && $setup.currentItem)
                  ? (_openBlock(), _createBlock($setup["DiscussionTime"], {
                      key: 4,
                      item: $setup.currentItem,
                      word: $setup.question.word
                    }, {
                      default: _withCtx(() => [
                        _createVNode($setup["Button"], {
                          backgroundcolour: 'bg-sl-green-button',
                          textcolour: 'text-white',
                          childclass: 'text-2xl border-none p-5',
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.finish()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["item", "word"]))
                  : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}